module.exports = __webpack_public_path__ + "img/icon-Customize.70bd1cab.png";